module.exports = __webpack_public_path__ + "img/title-5.41c53570.png";